import { useWindowWidth } from "./use-window-width.js";
const MOBILE_MAX_WIDTH = 600;
const TABLET_MAX_WIDTH = 839;
function useResponsiveBreakpoint() {
  const windowWidth = useWindowWidth();
  if (windowWidth === null) {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: false
    };
  }
  return {
    isMobile: windowWidth <= MOBILE_MAX_WIDTH,
    isTablet: windowWidth > MOBILE_MAX_WIDTH && windowWidth <= TABLET_MAX_WIDTH,
    isDesktop: windowWidth > TABLET_MAX_WIDTH
  };
}
export {
  useResponsiveBreakpoint
};
//# sourceMappingURL=use-responsive-breakpoint.js.map
